import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
} from 'date-fns';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import ClockIcon from '@/assets/icons/clock-sm-grey.svg';
import { Tooltip } from '@/components/ui/tooltip';
import { Typography } from '@/components/ui/typography';

interface TimestampProps {
  lastUpdatedAt: string;
}

export function Timestamp({ lastUpdatedAt }: TimestampProps) {
  const timeAgo = useMemo(() => {
    const now = new Date();

    const seconds = differenceInSeconds(now, lastUpdatedAt);
    if (seconds < 60) {
      return `${seconds}s ago`;
    }

    const minutes = differenceInMinutes(now, lastUpdatedAt);
    if (minutes < 60) {
      return `${minutes}m ago`;
    }

    const hours = differenceInHours(now, lastUpdatedAt);
    if (hours < 24) {
      return `${hours}h ago`;
    }

    const days = differenceInDays(now, lastUpdatedAt);
    return `${days}d ago`;
  }, [lastUpdatedAt]);

  return (
    <Tooltip
      content={
        <>
          <FormattedMessage
            defaultMessage="Last updated at:"
            description="Tooltip prefix before full timestamp for budget sync time"
          />
          <br />
          <br />
          <p>{format(lastUpdatedAt, 'MMMM d, yyyy h:mm a')}</p>
        </>
      }
    >
      <div className="flex items-center gap-1">
        <img src={ClockIcon} alt="" />
        <Typography as="span" variant="caption" className="text-fx-neutral-400">
          {timeAgo}
        </Typography>
      </div>
    </Tooltip>
  );
}
